import { ChangeDetectionStrategy,Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, RouterModule } from '@angular/router';

import { AdminComponentBase, PageSimpleContentComponent, PageStatus } from 'app/layout/content';
import { ErrorComponent } from 'app/shared/components/error.component';
import { SaveButtonComponent } from 'app/shared/components/save-button.component';
import { StoreConfig } from 'app/shared/graph';
import { CopyToClipboardComponent } from 'app/shared/utilities/copy-to-clipboard.component';

import { LibraryBranchesSelectorComponent } from './library-branches-selector.component';
import { LibrarySettingsService } from './library-settings.service';

@Component({
    selector: 'admin-library-settings-page',
    imports: [
        CopyToClipboardComponent,
        LibraryBranchesSelectorComponent,
        MatIconModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        PageSimpleContentComponent,
        ErrorComponent,
        SaveButtonComponent,
        RouterModule
    ],
    templateUrl: './store-library-settings-page.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './store-library-settings-page.component.scss'
})
export class StoreLibrarySettingsPageComponent extends AdminComponentBase implements OnInit, OnDestroy {
    private readonly route = inject(ActivatedRoute);
    private readonly librarySettingsService = inject(LibrarySettingsService);

    storeId: string;
    storeConfig?: StoreConfig;

    ngOnInit(): void {
        this.registerSubscription(this.route.params.subscribe(params => {
            this.storeId = params.storeId;
            this.subscribeWithGenericLoadingErrorHandling(this.librarySettingsService.getStoreConfig(this.storeId),
                storeWithConfig => {
                    this.storeConfig = { ...storeWithConfig.config };
                });
        }));
    }

    ngOnDestroy(): void {
        super.unsubscribeSubscriptions();
    }

    save() {
        if (!this.storeConfig) {
            return;
        }

        this.pageStatus = PageStatus.saving;
        this.subscribeWithGenericSavingErrorHandling(this.librarySettingsService.updateStoreConfig({
            storeId: this.storeId,
            defaultLibraryPackage: this.storeConfig.defaultLibraryPackage,
            defaultLibraryBranches: this.storeConfig.defaultLibraryBranches
        }));
    }
}
